import React, { useEffect } from "react";
import { Stack } from "@mui/material";
import { IFilter } from "../../../../types/filter.type";
import FilterText from "../FilterText";

function FilterCRDuongdung({ filter, setFilter, load }: IFilter) {
  const defaultFilter = {
    duongdung: "",
  };

  useEffect(() => {
    setFilter(defaultFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load]);

  return (
    <Stack sx={{ width: "100%" }} gap={2}>
      <FilterText
        label="Đường dùng"
        placeholder="Tìm theo đường dùng"
        defaultValue={filter.duongdung}
        onChange={(val) => setFilter({ ...filter, duongdung: val })}
      />
    </Stack>
  );
}

export default FilterCRDuongdung;
